import React from 'react';
import { Container, Box, Typography, Button, Stack } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FooterItems from './FooterItems';
import { useLang } from '../../utils/i18n';
import { openScheduleCall } from '../../utils/scheduleCall';

const COPY = {
  en: {
    headline: "Let’s work together",
    sub: "Strategy, prototypes, production: healthcare AI in weeks — not quarters.",
    cta: "Let's Talk",
    projects: "View Projects",
    help: "Need help or have questions? Ask Eva, my AI assistant.",
  },
  es: {
    headline: "Trabajemos juntos",
    sub: "Estrategia, prototipos, producción: IA para la salud en semanas — no trimestres.",
    cta: "Hablemos",
    projects: "Ver proyectos",
    help: "¿Necesitas ayuda o tienes dudas? Pregúntale a Eva, mi asistente de IA.",
  },
};

export default function Footer() {
  const [lang] = useLang();
  const t = COPY[lang] || COPY.en;

  return (
    <Box
      sx={{
        borderTop: '1px solid rgba(255,255,255,0.07)',
        bgcolor: '#030608',
        color: 'rgba(226,232,240,0.85)',
        mt: 0,
      }}
    >
      <Container maxWidth="lg" sx={{ py: 6, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1, color: '#e2e8f0' }}>
          {t.headline}
        </Typography>
        <Typography sx={{ opacity: 0.65, mb: 3 }}>
          {t.sub}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 4 }}>
          <Button
            onClick={openScheduleCall}
            variant="contained"
            color="primary"
            startIcon={<CalendarMonthIcon />}
            aria-label={t.cta}
            sx={{ px: 3 }}
          >
            {t.cta}
          </Button>
          <Button
            href="/projects"
            variant="outlined"
            sx={{
              color: 'rgba(226,232,240,0.75)',
              borderColor: 'rgba(255,255,255,0.15)',
              px: 3,
              '&:hover': { borderColor: '#06B6D4', color: '#06B6D4' },
            }}
          >
            {t.projects}
          </Button>
        </Stack>
        <FooterItems />
        <Typography variant="caption" sx={{ display: 'block', mt: 2, opacity: 0.5 }}>
          {t.help}
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mt: 2, opacity: 0.4 }}>
          © {new Date().getFullYear()} Martín Antúnez
        </Typography>
      </Container>
    </Box>
  );
}


